/* eslint-disable prettier/prettier */
/* eslint-disable sonarjs/prefer-single-boolean-return */
import moment from 'moment';

//to validate each values inside response
export const validateData = (value: any) => {
  if (value !== undefined && value !== null && value !== '') {
    return true;
  } else {
    return false;
  }
};

//to change price format
export const formatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  minimumFractionDigits: 2,
});

//to change price format without decimal point 
export const Priceformatter = new Intl.NumberFormat('en-US', {
  style: 'decimal', // Changed from 'currency' to 'decimal'
  minimumFractionDigits: 0, // No decimal points
  maximumFractionDigits: 0, // No decimal points
});

/**function for dateConvertion */
export const convertDate = (date: any, toFormat: any) => {
  return moment(date).format(toFormat);
};

export function sleep(ms: number) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

